import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { LoginRoutingModule } from './login-routing.module'
import { LoginComponent } from './components/login.component'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { AlertComponent } from './components/alert/alert.component'

import { ReactiveFormsModule } from '@angular/forms'
import { AgentNewPasswordComponent } from './agent-new-password/agent-new-password.component'
import { AgentListComponent } from './agent-list/agent-list.component'
import { AgentLinkComponent } from './agent-link/agent-link.component'
import { CodeInputModule } from 'angular-code-input'
import { AgentForgotPasswordComponent } from './agent-forgot-password/agent-forgot-password.component'
import { SharedModule } from '../shared/shared.module'

@NgModule({
  declarations: [LoginComponent, AlertComponent, AgentNewPasswordComponent, AgentListComponent, AgentLinkComponent, AgentForgotPasswordComponent],
  imports: [CommonModule, LoginRoutingModule, FormsModule, RouterModule, ReactiveFormsModule, CodeInputModule, SharedModule],
})
export class LoginModule {}
